import React from "react";
import { Check, X, Copy } from "lucide-react";
import toast from "react-hot-toast";

export default function AccountResultsTable({ results }) {
    if (!results || results.length === 0) {
        return null;
    }

    const handleCopyPassword = (password, name) => {
        navigator.clipboard.writeText(password);
        toast.success(`Copied password for ${name}`);
    };

    const handleCopyAll = () => {
        const successResults = results.filter((r) => r.success);
        const text = successResults
            .map(
                (r) =>
                    `Name: ${r.name}\nEmail: ${r.email}\nPassword: ${r.password}`
            )
            .join("\n\n");
        navigator.clipboard.writeText(text);
        toast.success("Copied all credentials to clipboard");
    };

    const successCount = results.filter((r) => r.success).length;
    const failureCount = results.filter((r) => !r.success).length;

    return (
        <div className="w-full mt-6">
            <div className="border-2 border-base-content overflow-hidden">
                {/* Header */}
                <div className="border-b-2 border-base-content p-4 bg-base-200">
                    <div className="flex justify-between items-center mb-2">
                        <h2 className="text-lg font-bold">
                            ACCOUNT CREATION RESULTS
                        </h2>
                        {successCount > 0 && (
                            <button
                                className="btn btn-sm btn-outline"
                                onClick={handleCopyAll}
                            >
                                <Copy size={16} className="mr-2" />
                                Copy All
                            </button>
                        )}
                    </div>
                    <div className="text-sm">
                        <span className="text-success">
                            ✓ Success: {successCount}
                        </span>{" "}
                        <span className="text-error">
                            ✗ Failed: {failureCount}
                        </span>
                    </div>
                </div>

                {/* Results Table */}
                <div className="overflow-x-auto">
                    <table className="table w-full">
                        <thead>
                            <tr className="border-b-2 border-base-content">
                                <th className="border-r-2 border-base-content">
                                    Status
                                </th>
                                <th className="border-r-2 border-base-content">
                                    Name
                                </th>
                                <th className="border-r-2 border-base-content">
                                    Email
                                </th>
                                <th className="border-r-2 border-base-content">
                                    Password
                                </th>
                                <th>Error</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.map((result, index) => (
                                <tr
                                    key={index}
                                    className={`border-b border-base-content ${
                                        result.success
                                            ? "bg-base-100"
                                            : "bg-error/10"
                                    }`}
                                >
                                    <td className="border-r-2 border-base-content text-center">
                                        {result.success ? (
                                            <Check
                                                className="text-success mx-auto"
                                                size={20}
                                            />
                                        ) : (
                                            <X
                                                className="text-error mx-auto"
                                                size={20}
                                            />
                                        )}
                                    </td>
                                    <td className="border-r-2 border-base-content">
                                        {result.name || "N/A"}
                                    </td>
                                    <td className="border-r-2 border-base-content">
                                        {result.email || "N/A"}
                                    </td>
                                    <td className="border-r-2 border-base-content">
                                        {result.success ? (
                                            <div className="flex items-center gap-2">
                                                <code className="bg-base-200 px-2 py-1 rounded font-mono">
                                                    {result.password}
                                                </code>
                                                <button
                                                    className="btn btn-xs btn-ghost"
                                                    onClick={() =>
                                                        handleCopyPassword(
                                                            result.password,
                                                            result.name
                                                        )
                                                    }
                                                >
                                                    <Copy size={14} />
                                                </button>
                                            </div>
                                        ) : (
                                            <span className="text-base-content/50">
                                                N/A
                                            </span>
                                        )}
                                    </td>
                                    <td>
                                        {result.error ? (
                                            <span className="text-error text-xs">
                                                {result.error}
                                            </span>
                                        ) : (
                                            <span className="text-base-content/50">
                                                -
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
